import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InputDelayPage from '../../../../components/input-delay-page/input-delay-page';
import queryString from 'query-string';

const OtherTcDelayPage = (props) => {
	const { params = {} } = props;
	const { redirectUrl = '' } = params;
	const { id } = useParams();
	const location = useLocation();
	const param = queryString.parse(location.search);
	const { t } = useTranslation();

	return (
		<InputDelayPage
			driveLogId={id}
			fieldToUpdate="other_tc_time"
			additionnalFields={{}}
			title={t('dl:add-delay-page.other-tc')}
			reasonField={'other_tc_reason'}
			redirect={param?.redirect}
			redirectUrl={redirectUrl}
		/>
	);
};

export default OtherTcDelayPage;
